module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ;  var checked = pgIntArrayDecode(widget.item[column.name]) 
    ; __append("\n\n")
    ;  column.enum.each(function (value) { 
    ; __append("\n<div>\n	<label>\n		<input\n			type=\"checkbox\"\n			data-column=\"")
    ; __append(escapeFn( column.name ))
    ; __append("\"\n			value=\"")
    ; __append(escapeFn( value ))
    ; __append("\"\n			on-click=\"onPGEnumChecksColumnClick\"\n			")
    ; __append(escapeFn( ~checked.indexOf(+value) ? "checked" : "" ))
    ; __append("\n			>\n\n		<span>")
    ; __append(escapeFn( column.enum.title(value) ))
    ; __append("</span>\n	</label>\n</div>\n")
    ;  }) 
    ; __append("\n")
  }
  return __output.join("");

}